import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=768b1267&scoped=true&"
import script from "./BusinessInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&id=768b1267&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b1267",
  null
  
)

export default component.exports